import React from "react";
import { Box } from "@mui/material";
import KeyOperatorFilter from "./KeyOperatorFilter";
import { PaginationDropdown } from "components/Pagination";
import SearchInput from "components/SearchInput";
import ResetButton from "components/ResetButton";

const GenericFilterSection = ({
  isAdminContext,
  entityConfig,
  keysWithOperators,
  search,
  rows,
  onKeyChange,
  onSearchChange,
  onReset,
  onRowsPerPageChange,
  addRoute,
  navigate,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        margin: 1,
        flexWrap: { xs: "wrap", sm: "nowrap" },
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        {isAdminContext && (
          <KeyOperatorFilter
            entityConfig={entityConfig}
            keysWithOperators={keysWithOperators}
            onKeyChange={onKeyChange}
          />
        )}
        {keysWithOperators.length > 0 && <ResetButton onReset={onReset} />}
      </Box>
      <SearchInput
        value={search}
        onChange={(value) => onSearchChange(value)}
        label={"Search by filters"}
        type="search"
        sx={{
          m: 1,
          minWidth: 50,
          width: 300,
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
          }
        }}
      />
      <PaginationDropdown
        rows={rows}
        onRowsPerPageChange={onRowsPerPageChange}
        addRoute={addRoute}
        navigate={navigate}
      />
    </Box>
  );
};

export default GenericFilterSection;
